import { useEffect } from "react";
import Phaser from "phaser";
import BootScene from "./scenes/BootScene";
import RoomScene from "./scenes/RoomScene";

export default function PhaserGame() {
  useEffect(() => {
    const config = {
      type: Phaser.AUTO,
      width: "100%",
      height: 800,
      parent: "game-container",
      physics: {
        default: "arcade",
        arcade: {
          debug: false,
        },
      },
      scene: [BootScene, RoomScene],
    };

    new Phaser.Game(config);
  }, []);

  return <div id="game-container" />;
}
